import React from "react";
import { Text, View } from "@react-pdf/renderer";
import styles from "../quote-page.styles";

const P1Prepared = ({ loc, claimant, showDOB, quoteTitle }) => {
  const showTitle = quoteTitle.trim().length >= 1 ? true : false;

  const ShowAgeOrDate = () => {
    const dob = claimant.birthDate;
    const ageString = `Age: ${claimant.displayedAge}`;
    const dobString = `Date of Birth: ${dob}`;
    return claimant.ageSelector ? ageString : dobString;
  };

  return (
    <View style={loc}>
      <Text style={[styles.text18, styles.center]}>PREPARED FOR:</Text>
      <Text
        style={[styles.text22, styles.center, styles.bold, styles.margin10_top]}
      >
        {claimant.name}
      </Text>
      {claimant.caseNumber.length >= 1 && (
        <Text style={[styles.text18, styles.center, styles.margin5_top]}>
          {`Case Number: ${claimant.caseNumber}`}
        </Text>
      )}
      {showDOB && (
        <>
          <Text style={[styles.text18, styles.center]}>
            <ShowAgeOrDate />
          </Text>
          {claimant.ratedAge > claimant.age && (
            <Text style={[styles.text18, styles.center]}>
              {`Rated Age: ${claimant.ratedAge}`}
            </Text>
          )}
        </>
      )}
      {showTitle && (
        <>
          <Text style={[styles.text18, styles.center]}>
            {`${quoteTitle.trim()}`}
          </Text>
        </>
      )}
    </View>
  );
};

export default P1Prepared;
